import {
  FETCH_CPM_DETAILS,
  FETCH_CPM_DETAILS_START,
  FETCH_CPM_DETAILS_SUCCESS,
  FETCH_CPM_DETAILS_ERROR,
  FETCH_CPM_DETAILS_SELECTION,
  FETCH_CPM_DETAILS_SELECTION_START,
  FETCH_CPM_DETAILS_SELECTION_SUCCESS,
  FETCH_CPM_DETAILS_SELECTION_ERROR,
  POST_CPM_DETAILS,
  POST_CPM_DETAILS_START,
  POST_CPM_DETAILS_SUCCESS,
  POST_CPM_DETAILS_ERROR,
  UPDATE_CPM_DETAILS_CHANGE,
  RESET_CPM_DETAILS_CHANGE,
  UPDATE_NINE_HUNDRED_LEVEL_PART_NUMBER,
  UPDATE_PROJECT_PRIORITY_ID,
  UPDATE_PRODUCT_SAMPLED_ID,
  UPDATE_READY_FOR_REVIEW_ID,
  UPDATE_PUBLISH_TO_WEB_ID,
  UPDATE_CPM_NOTES,
  UPDATE_GENERAL_AVAILABILITY,
  UPDATE_PROD_RELEASE,
} from './constants'

const fetchCpmDetails = (projectId) => ({ type: FETCH_CPM_DETAILS, projectId })
const fetchCpmDetailsStart = () => ({ type: FETCH_CPM_DETAILS_START })
const fetchCpmDetailsSuccess = () => ({ type: FETCH_CPM_DETAILS_SUCCESS })
const fetchCpmDetailsError = (error) => ({ type: FETCH_CPM_DETAILS_ERROR, error })

const fetchCpmDetailsSelection = () => ({ type: FETCH_CPM_DETAILS_SELECTION })
const fetchCpmDetailsSelectionStart = () => ({ type: FETCH_CPM_DETAILS_SELECTION_START })
const fetchCpmDetailsSelectionSuccess = () => ({ type: FETCH_CPM_DETAILS_SELECTION_SUCCESS })
const fetchCpmDetailsSelectionError = (error) => ({ type: FETCH_CPM_DETAILS_SELECTION_ERROR, error })

const postCpmDetails = (projectId, params) => ({ type: POST_CPM_DETAILS, projectId, params })
const postCpmDetailsStart = () => ({ type: POST_CPM_DETAILS_START })
const postCpmDetailsSuccess = () => ({ type: POST_CPM_DETAILS_SUCCESS })
const postCpmDetailsError = (error) => ({ type: POST_CPM_DETAILS_ERROR, error })

const updateCpmDetailsChange = (details) => ({ type: UPDATE_CPM_DETAILS_CHANGE, details })
const resetCpmDetailsChange = (details) => ({ type: RESET_CPM_DETAILS_CHANGE, details })

const updateNineHundredLevelPartNumber = (partNumber) => ({ type: UPDATE_NINE_HUNDRED_LEVEL_PART_NUMBER, partNumber })
const updateProjectPriorityId = (projectPriorityId) => ({ type: UPDATE_PROJECT_PRIORITY_ID, projectPriorityId })
const updateProductSampledId = (productSampledId) => ({ type: UPDATE_PRODUCT_SAMPLED_ID, productSampledId })
const updateReadyForReviewId = (readyForReviewId) => ({ type: UPDATE_READY_FOR_REVIEW_ID, readyForReviewId })
const updatePublishToWebId = (publishToWebId) => ({ type: UPDATE_PUBLISH_TO_WEB_ID, publishToWebId })
const updateCpmNotes = (cpmNotes) => ({ type: UPDATE_CPM_NOTES, cpmNotes })
const updateProdRelease = (prodRelease) => ({type: UPDATE_PROD_RELEASE, prodRelease})
const updateGeneralAvailability = (generalAvailability) => ({type: UPDATE_GENERAL_AVAILABILITY, generalAvailability})

export {
  fetchCpmDetails,
  fetchCpmDetailsStart,
  fetchCpmDetailsSuccess,
  fetchCpmDetailsError,
  fetchCpmDetailsSelection,
  fetchCpmDetailsSelectionStart,
  fetchCpmDetailsSelectionSuccess,
  fetchCpmDetailsSelectionError,
  postCpmDetails,
  postCpmDetailsStart,
  postCpmDetailsSuccess,
  postCpmDetailsError,
  updateCpmDetailsChange,
  resetCpmDetailsChange,
  updateNineHundredLevelPartNumber,
  updateProjectPriorityId,
  updateProductSampledId,
  updateReadyForReviewId,
  updatePublishToWebId,
  updateCpmNotes,
  updateGeneralAvailability,
  updateProdRelease
}
